export const apiName: string = 'tipos-logradouros';



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/enderecos/tipos-logradouro/shared/data.service.ts
 **/